import { render, staticRenderFns } from "./MidiaTelaCheia.vue?vue&type=template&id=e6992caa&scoped=true"
import script from "./MidiaTelaCheia.vue?vue&type=script&lang=js"
export * from "./MidiaTelaCheia.vue?vue&type=script&lang=js"
import style0 from "./MidiaTelaCheia.vue?vue&type=style&index=0&id=e6992caa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6992caa",
  null
  
)

export default component.exports